<template>
  <v-row>
    <v-col class="d-flex justify-center pr-0" v-for="(item, index) in dialogPin" :key="index">
      <v-btn small text dark @click.stop="dialog = true" class="px-0 pb-0 mb-0 align-end">
        <span class="d-flex primary--text text-capitalize text-caption">{{ item.btn }}</span>
      </v-btn>
      <v-dialog v-model="dialog" max-width="500">
        <v-card style="height: 280px">
          <v-card-title class="text-subtitle-1 pt-7">{{ item.title }}</v-card-title>
          <v-card-text>{{ item.text }}</v-card-text>
          <v-card-actions>
            <v-row>
              <v-col cols="12">
                <template>
                  <div>
                    <div class="ma-auto position-relative" style="max-width: 200px">
                      <v-otp-input
                        v-model="otp"
                        length="4"
                        :disabled="loading"
                        @finish="onFinish"
                      ></v-otp-input>
                      <v-overlay absolute :value="loading">
                        <v-progress-circular indeterminate color="primary"></v-progress-circular>
                      </v-overlay>
                    </div>
                    <span class="d-flex justify-center text-caption mt-5">
                      {{ text }}
                    </span>
                  </div>
                </template>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'VDialogPin',
  props: ['dialogPin'],
  data() {
    return {
      dialog: false,
      loading: false,
      otp: '',
      text: '',
    };
  },
  computed: {
    ...mapGetters('usersCodeVerif', ['usersPin']),
  },
  methods: {
    ...mapActions('usersCodeVerif', ['getUsersPin']),

    async onFinish() {
      this.loading = true;
      let dialogPin = this.dialogPin[0];
      const type = dialogPin.type;

      let model = {};
      model.otp = this.otp;
      model.type = type;

      await this.$store.dispatch('usersCodeVerif/getUsersPin', { model });
      const usersPin = this.usersPin;

      if (usersPin === true) {
        setTimeout(() => {
          this.loading = false;
          this.text = 'PIN de Usuario es correcto';
          this.snackbar = true;
        }, 3500);
        this.dialog = false;
        if (this.$route.name === 'my-account') {
          this.$store.dispatch('proAccountPage/loadModelForm', { usersPin });
        } else if (this.$route.name === 'profile-a') {
          this.$store.dispatch('proProfileAPage/loadModelForm', { usersPin });
        } else if (this.$route.name === 'patients-b') {
          this.$store.dispatch('proPatientsBPage/loadDataCrud', { usersPin });
        } else if (this.$route.name === 'patients-c') {
          this.$store.dispatch('proPatientsCPage/loadModelForm', { usersPin });
        } else if (this.$route.name === 'patient-a') {
          this.$store.dispatch('patProfileAPage/loadModelForm', { usersPin });
        } else if (this.$route.name === 'my-account-pat') {
          this.$store.dispatch('patAccountPage/loadModelForm', { usersPin });
        } else {
          this.$store.dispatch('anamLineData/loadModelForm', { usersPin });
        }
      } else if (usersPin === false) {
        setTimeout(() => {
          this.loading = false;
          this.text = 'PIN de Usuario es incorrecto';
          this.snackbar = true;
        }, 3500);
      }
      this.otp = '';
      this.text = ' ';
    },
  },
};
</script>

<style scoped>
.position-relative {
  position: relative;
}
</style>
